type KeyHandler = (event: KeyboardEvent | React.KeyboardEvent) => void;

interface KeyConfig {
  keys: string[];
  handler: KeyHandler;
  preventDefault?: boolean;
}

export function onKeyDown(configs: KeyConfig[]) {
  return (event: KeyboardEvent | React.KeyboardEvent) => {
    for (const config of configs) {
      if (config.keys.map((k) => k.toLowerCase()).includes(event.key.toLowerCase())) {
        if (config.preventDefault) {
          event.preventDefault();
        }
        config.handler(event);
        break;
      }
    }
  };
}
